//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const katana = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 4, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 2, 4, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 2, 4, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 2, 4, 0, 0, 0, 0, 
    0, 0, 5, 5, 0, 2, 4, 0, 0, 0, 0, 0, 
    0, 0, 5, 1, 2, 2, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 
    0, 0, 3, 1, 1, 1, 5, 0, 0, 0, 0, 0, 
    0, 3, 3, 0, 0, 5, 5, 0, 0, 0, 0, 0, 
    3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]